import { useState, type ReactNode } from "react";
import { loadPassword, savePassword } from "../state/local";

/**
 * Asks for the site password once per device before showing anything. A light lock that keeps
 * strangers who find the address from playing, not real security: the password is built into
 * the bundle (VITE_TC_PASSWORD), and the server does not check it. Empty = no gate. A device
 * that entered an older password is asked again.
 */
export function PasswordGate({ password, children }: { password: string; children: ReactNode }) {
  const [unlocked, setUnlocked] = useState(() => !password || loadPassword() === password);
  const [value, setValue] = useState("");
  const [wrong, setWrong] = useState(false);

  if (unlocked) return <>{children}</>;

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (value.trim() === password) {
      savePassword(password);
      setUnlocked(true);
    } else {
      setWrong(true);
    }
  };

  return (
    <main className="screen screen-center" data-screen="password">
      <div className="stack" style={{ marginBottom: 24 }}>
        <div className="home-mark" aria-hidden>
          ◷
        </div>
        <h1>TowerClock</h1>
      </div>

      <form className="card stack" onSubmit={submit}>
        <div className="field">
          <label htmlFor="password">Enter password</label>
          <input
            id="password"
            className="input"
            type="password"
            value={value}
            onChange={(e) => {
              setValue(e.target.value);
              setWrong(false);
            }}
            autoComplete="off"
            autoFocus
          />
        </div>
        <button className="btn btn-primary" type="submit" disabled={!value.trim()}>
          Enter
        </button>
        {wrong && <p className="error-text">Wrong password.</p>}
      </form>
    </main>
  );
}
